import { LAB_REPORT } from "@/api_framework/api_config";
import {
  ILabReportInterpretationEMR,
  ILabReportInterpretationEMRUpdatePayload,
} from "@/api_framework/api_modals/LabReportInterpretation";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import axios, { AxiosError, AxiosResponse } from "axios";
import AxiosCurlirize from "axios-curlirize";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";

AxiosCurlirize(axios, () => {});

export const useLabReportInterpretationEMRUpdateAPI = () => {
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const [loading, setLoading] = useState(false);

  const execute = useCallback(
    async (payload: ILabReportInterpretationEMRUpdatePayload): Promise<ILabReportInterpretationEMR | null> => {
      setLoading(true);
      const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
      return axios
        .put(LAB_REPORT.LAB_REPORT_INTERPRETATION_EMR_UPDATE.baseURL, payload, {
          headers: {
            Authorization: `${accessToken}`,
            "Content-Type": "application/json",
          },
        })
        .then((res: AxiosResponse<{ status: boolean; message: string; data: ILabReportInterpretationEMR }>) => {
          if (res.data?.status === true) return res.data.data;
          toast.error(res.data?.message || "Unable to save interpretation");
          return null;
        })
        .catch((e: AxiosError<{ message?: string }>) => {
          sendCurl(e.config?.["curlCommand"]);
          toast.error(e.response?.data?.message || "Unable to save interpretation");
          return null;
        })
        .finally(() => setLoading(false));
    },
    [],
  );

  return { execute, loading };
};
